import Authenticator2 from "../../auth/Authenticator2";
import AuthenticationController from "../../controllers/AuthenticationController";
import PreviewAuthController from "../../controllers/preview/PreviewAuthController";

export default class SessionUtil {
	static logout() {
		PreviewAuthController.logoutFromReviewServer();
        AuthenticationController.logout((resp) => {
          if (resp) {
            const globalUrl = resp.getGlobalLogoutURLs();
            if (globalUrl) {
              Authenticator2.AUTH_STORE.put(Authenticator2.GLOBAL_LOGOUT_URL, globalUrl[0]);
            }
            AuthenticationController.onLogoutResp();
          }
        });
	}
} 